export default "__VITE_ASSET__0e200e29__"